<template>
  <div>
    <div class="gradient-row1">
      <div class="content">
        <h3>自选基金助手-实时查看基金涨跌幅</h3>
        <h4>实时获取您关注基金的涨跌与估值，助你快速获取收益情况</h4>
        <div class="btn-row">
          <el-button type="success" @click="openPage('Download')"
            >安装使用<i class="el-icon-arrow-right"></i
          ></el-button>
          <el-button type="primary" @click="openPage('Directions')"
            >查看说明 <i class="el-icon-warning-outline"></i
          ></el-button>
        </div>
        <div class="img-row">
          <el-image
            fit="contain"
            src="https://github.com/x2rr/Picture/raw/master/img/popup.png"
          ></el-image>
        </div>
      </div>
    </div>
    <div class="gradient-row2">
      <div class="content">
        <div class="intro-list">
          <div class="intro-list-row">
            <div class="intro-icon">
              <div class="intro-icon-img icon-img1"></div>
            </div>
            <h6>实时角标提醒</h6>
            <p class="intro-tip">实时信息显示在角标中</p>
          </div>
          <div class="intro-list-row">
            <div class="intro-icon">
              <div class="intro-icon-img icon-img2"></div>
            </div>
            <h6>自动计算收益</h6>
            <p class="intro-tip">自动计算当日收益，持有收益</p>
          </div>
          <div class="intro-list-row">
            <div class="intro-icon">
              <div class="intro-icon-img icon-img3"></div>
            </div>
            <h6>基金走势图</h6>
            <p class="intro-tip">查看当日估值走势图、历史走势图</p>
          </div>
          <div class="intro-list-row">
            <div class="intro-icon">
              <div class="intro-icon-img icon-img4"></div>
            </div>
            <h6>自定义配置</h6>
            <p class="intro-tip">支持自定义配置展示内容</p>
          </div>
        </div>
      </div>
    </div>
    <div class="gradient-row3">
      <div class="content">
        <h5>主要功能</h5>
        <ul>
          <li>支持基金分组功能</li>
          <li>支持与“韭菜计算助手“小程序数据同步</li>
          <li>实时角标提醒</li>
          <li>单个基金特别关注</li>
          <li>角标内容自定义，单个、全部、收益额、收益率</li>
          <li>支持标准与暗色两种主题</li>
          <li>基金列表与配置信息支持导入与导出</li>
          <li>智能判断节假日，切换休市状态</li>
          <li>支持设置份额，查看当日估值收益</li>
          <li>支持设置持仓成本价，查看持有收益</li>
          <li>支持手动加仓减仓功能</li>
          <li>支持账号登录功能，方便跨平台同步</li>
          <li>交易日更新当日实际净值后，对应基金有 √ 提示</li>
          <li>支持查看估值走势图，净值、收益等走势图</li>
          <li>支持支持查看基金的股票持仓明细与走势图</li>
          <li>自定义顶部指数内容</li>
          <li>自定义基金列表展示内容</li>
          <li>指数与基金拖拽排序功能</li>
          <li>基金按照指定项排序功能</li>
          <li>行情中心展示，板块信息</li>
          <li>添加基金时支持模糊搜索，支持批量添加</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Main',
  components: {},
  data() {
    return {};
  },
  methods: {
    openPage(page) {
      this.$router.push(page);
    },
  },
};
</script>

<style lang="scss" scoped>
.gradient-row1 {
  background: linear-gradient(#f5f7fa, #c3cfe2);
  padding-top: 70px;
}
.gradient-row2 {
  background: linear-gradient(#72afd3, #37ecba);
  .intro-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    .intro-list-row {
      padding: 60px 12px;
      box-sizing: border-box;
      h6 {
        font-size: 20px;
        font-weight: bold;
        margin: 20px 10px 10px;
      }
      .intro-tip {
        color: #6e6e6e;
        font-size: 15px;
      }
      .intro-icon {
        width: 70px;
        height: 70px;
        border-radius: 50px;
        box-sizing: border-box;
        padding: 10px;
        margin: 0 auto;
        overflow: hidden;
        background-color: #fff;

        .intro-icon-img {
          width: 50px;
          height: 50px;

          background-size: 100%;
          background-repeat: no-repeat;
        }
        .icon-img1 {
          background-image: url('../assets/tip1.png');
        }
        .icon-img2 {
          background-image: url('../assets/money.png');
        }
        .icon-img3 {
          background-image: url('../assets/line.png');
        }
        .icon-img4 {
          background-image: url('../assets/setting.png');
        }
      }
    }
  }
}

.gradient-row3 {
  background: linear-gradient(#fef9d7, #d299c2);
  h5 {
    font-size: 32px;
    font-weight: normal;
    margin: 25px 25px 30px;
  }
  ul {
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    margin: 20px 0;
    li {
      width: 50%;
      text-align: left;
      font-size: 18px;
      padding: 8px 25px;
      box-sizing: border-box;
      position: relative;
      &::before {
        font-family: element-icons !important;
        content: '\e6da';
        position: absolute;
        left: 4px;
        top: 11px;
        font-weight: bold;
      }
    }
  }
}
.content {
  margin: 0 auto;
  padding: 40px 20px 30px;
  box-sizing: border-box;
  .img-row {
    padding: 40px 0;
    .el-image {
      max-width: 100%;
      box-shadow: 0 0 10px #666;
    }
  }
}
h3 {
  font-size: 34px;
  font-weight: normal;
}
h4 {
  font-size: 24px;
  margin: 5px 0 25px;
  font-weight: normal;
  color: #727272;
}

.btn-row {
  padding: 10px 0;
  .el-button {
    padding: 15px 20px;
    font-size: 17px;
    margin: 10px 15px;
  }
}

@media (min-width: 1200px) {
  .intro-list-row {
    width: 25%;
  }
  .gradient-row3 {
    ul {
      li {
        width: 50%;
      }
    }
  }
}
@media (min-width: 768px) and (max-width: 1199px) {
  .intro-list-row {
    width: 25%;
  }
  .gradient-row3 {
    ul {
      li {
        width: 50%;
      }
    }
  }
}
@media (min-width: 480px) and (max-width: 767px) {
  .intro-list-row {
    width: 50%;
  }
  .gradient-row3 {
    ul {
      li {
        width: 100%;
      }
    }
  }
}
@media (max-width: 479px) {
  .intro-list-row {
    width: 100%;
  }
  .gradient-row3 {
    ul {
      li {
        width: 100%;
      }
    }
  }
}
</style>
